import {BaseLessonFragment} from "./BaseLessonFragment";
import {colorPastelBlue} from "../../shared/colors";

export enum LessonType {
  FLIP,
  RECORD_AUDIO,
}

export enum AnswerState {
  NONE,
  CORRECT,
  INCORRECT,
}

export interface LessonContext {
  pageIndex(): number;

  nextPage(): void;

  setPageIndex(index: number): void;

  selectedOptionIndex(): number | null;

  setSelectedOptionIndex(optionIndex: number | null): void;

  answerState(): AnswerState;
}

export enum CategoryId {
  SCENARIOS = "scenarios",
}

export type Category = {
  id: CategoryId,
  text: string,
}

export const CATEGORIES: Category[] = [
  {
    id: CategoryId.SCENARIOS,
    text: "Scenarios",
  },
];

export enum LessonId {
  SCENARIO_ORDERING_COFFEE = "scenarioOrderingCoffee",
}

export type Lesson = {
  id: LessonId,
  categoryId: CategoryId,
  text: string,
  titleLines: string[],
  background: string,
  renderClass: typeof BaseLessonFragment<any, any>,
}
